import React, { useEffect } from "react";
import Close from "../Icons/Close";

export function SuccessSnackbar(props) {
  useEffect(() => {
    if (props.open) {
      props.onEntering();
      const timer = setTimeout(() => {
        props.onClose();
      }, props.autoHideDuration);
      return () => clearTimeout(timer);
    }
  }, []);
  return (
    <div className="bandeau-message succes">
      {" "}
      <p>{props.message}</p>
      <a onClick={props.onClose} href="#" className="close-bandeau">
        <Close className="img-fluid" alt="" />
      </a>
    </div>
  );
}

export function ErrorSnackbar(props) {
  useEffect(() => {
    if (props.open) {
      const timer = setTimeout(() => {
        props.onClose();
      }, props.autoHideDuration);
      return () => clearTimeout(timer);
    }
  }, []);
  return (
    <div className="bandeau-message alerte">
      {" "}
      <p>{props.message}</p>{" "}
      <a onClick={props.onClose} href="#" className="close-bandeau">
        <Close className="img-fluid" alt="" />
      </a>
    </div>
  );
}
